import { createAction } from '@ngrx/store';

export enum RootActionTypes {
  LOGOUT = '[Root] Logout',
}

export const logout = createAction(RootActionTypes.LOGOUT);
